<div class="modal__content">
    <div class="confirmation-popup-header">
        <i class="fa-solid fa-link"></i>
        <span>{{title}}</span>
    </div>
    <div class="confirmation-popup-text">
        <span>{{description}}</span>
    </div>
    <div class="input-section">
        <span class="input-label">{{inputLabel}}</span><br>
        <div class="input-row">
            <div class="input-wrapper">
                <input type="text" class="name-input-box" id="popup-service-input" [placeholder]="inputPlaceholder"
                    [value]="inputValue" (input)="inputValue = $event.target.value">
                <div class="input-icons">
                    <i class="fa-solid fa-link link-icon"></i>
                </div>
            </div>
            <div class="trash-icon" [class.disabled]="!inputValue" (click)="inputValue && onTrashClick()">
                <i class="fa-solid fa-trash"></i>
            </div>
        </div>

        <div [class.hidden]="!errorMessage" class="error-message">
            {{ errorMessage }}
        </div>
    </div>
</div>
<div class="modal__footer">
    <button type="reset" class="btn btn-link" (click)="onCancel()">{{cancelButtonText}}</button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()">
        {{submitButtonText}}
    </button>
</div>